module.exports = __webpack_public_path__ + "static/48-8777d0fdd0bd1e86262a2b48c6d1443f.jpg";